module.exports = __webpack_public_path__ + "static/media/consupdate12.88e96bc7.jpg";